import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 12/13;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 13 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Files" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="files-list" transform="translate(-1235.000000, -130.000000)" fill={color} fillRule="nonzero">
                <g id="Group-32" transform="translate(1230.000000, 124.000000)">
                    <g id="dropbox-logo" transform="translate(5.000000, 6.000000)">
                        <polygon id="Path" points="3.82818611 8.66666667 6.5 6.5734424 2.64064638 4.33333333 0 6.32378968"></polygon>
                        <polygon id="Path" points="6.5 6.57335542 9.1796947 8.66666667 13 6.32369232 10.3594357 4.33333333"></polygon>
                        <polygon id="Path" points="6.50387181 7.05638261 6.50387181 7.04166667 6.49618234 7.04902464 6.48838457 7.04166667 6.48838457 7.05638261 3.84472323 9.13520226 2.70833333 8.43252866 2.70833333 9.22293391 6.48838457 11.3677189 6.48838457 11.375 6.49618234 11.3677189 6.50387181 11.375 6.50387181 11.3677189 10.2916667 9.22293391 10.2916667 8.43252866 9.15524969 9.13520226"></polygon>
                        <polygon id="Path" points="0 2.34687971 2.64064638 4.33333333 6.5 2.09679497 3.82818611 0"></polygon>
                        <polygon id="Path" points="9.1796947 0 6.5 2.09679497 10.3594357 4.33333333 13 2.34687971"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconDropbox extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
